import { render } from "./EditPluginInstall.vue?vue&type=template&id=cc574312&scoped=true"
import script from "./EditPluginInstall.vue?vue&type=script&lang=js"
export * from "./EditPluginInstall.vue?vue&type=script&lang=js"

import "./EditPluginInstall.vue?vue&type=style&index=0&id=cc574312&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc574312"]])

export default __exports__